var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdmin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 800.003,
    height: 618.867,
    viewBox: "0 0 800.003 618.867",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-560 -231)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.18,488.765a1.456,1.456,0,0,0,1.308,1.575H668.472a1.6,1.6,0,0,0,0-3.15H16.488a1.456,1.456,0,0,0-1.308,1.575Z",
    transform: "translate(621.678 359.527)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.105,370.945a27.478,27.478,0,0,1-54.387,0H229.146V524.776H422.677V370.945H353.105Z",
    transform: "translate(634.09 321.941)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M789.214,487.736H10.789A10.8,10.8,0,0,1,0,476.947V32.7A10.8,10.8,0,0,1,10.789,21.911H789.214A10.8,10.8,0,0,1,800,32.7V476.947a10.8,10.8,0,0,1-10.789,10.789Z",
    transform: "translate(560 209.089)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 761.747,
    height: 429.819,
    transform: "translate(580.088 249.003)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 360,
    rx: 4,
    transform: "translate(609 273)",
    fill: "#Ff4654"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6,0H26a6,6,0,0,1,6,6v4a6,6,0,0,1-6,6H6a6,6,0,0,1-6-6V6A6,6,0,0,1,6,0Z",
    transform: "translate(647 288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H76a4,4,0,0,1,4,4v8a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(623 601)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H76a4,4,0,0,1,4,4v8a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(750 273)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 88,
    rx: 8,
    transform: "translate(750 311)",
    fill: "#Ff4654"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    rx: 8,
    transform: "translate(623 320)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 528,
    height: 66,
    rx: 16,
    transform: "translate(750 567)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4,0H76a4,4,0,0,1,4,4v8a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V4A4,4,0,0,1,4,0Z",
    transform: "translate(1198 273)",
    fill: "#Ff4654"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    rx: 8,
    transform: "translate(623 344)",
    fill: "#fff",
    opacity: 0.149
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    rx: 8,
    transform: "translate(623 368)",
    fill: "#fff",
    opacity: 0.149
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    rx: 8,
    transform: "translate(623 392)",
    fill: "#fff",
    opacity: 0.149
  }), /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 16,
    rx: 8,
    transform: "translate(623 416)",
    fill: "#fff",
    opacity: 0.149
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 88,
    rx: 8,
    transform: "translate(1118 311)",
    fill: "#Ff4654"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 88,
    rx: 8,
    transform: "translate(934 311)",
    fill: "#Ff4654"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 528,
    height: 66,
    rx: 16,
    transform: "translate(750 489)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 528,
    height: 66,
    rx: 16,
    transform: "translate(750 411)",
    fill: "#f2f2f2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmin);
export default __webpack_public_path__ + "static/media/admin.27832aaaababcea9319ef2b60ed6d500.svg";
export { ForwardRef as ReactComponent };